export class NotificationCount {
    messages?: number;

    static fromJson(fields: any): NotificationCount {
        let item = Object.assign(new this(), fields);
        return item;
    }
}
